import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({name: 'translateByObject'})
export class TranslateByObjectPipe implements PipeTransform {

  constructor(@Inject('$translate') private $translate) {
  }
  transform(value: object, property: string): any {
    if(this.$translate.use() == 'fr_CA') {
      return value[property + 'FrCa'];
    }
    else if (this.$translate.use() == 'en') {
      return value[property + 'En'];
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/translate-by-object.pipe.ts